export default __webpack_public_path__ + "static/smart_contract_code_pm-b0f9713fab40f1111fcd2be07f4bc36d.png";